import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';
import { validationText } from '@/util/master/masterErrors';

// Pakai axiosInstance global, jangan .create() kayak MasterApi: baseURL-nya bisa ketimpa undefined.
export function createMasterCrud(masterName) {
  const basePath = `/master/${masterName}`;

  return {
    async list(params) {
      const { data } = await axiosInstance.get(basePath, {
        params,
        cancelToken: getNewCancelToken(),
      });
      return data;
    },
    async get(id) {
      const { data } = await axiosInstance.get(`${basePath}/${id}`, {
        cancelToken: getNewCancelToken(),
      });
      return data;
    },
    async create(payload) {
      const { data } = await axiosInstance.post(basePath, payload, {
        cancelToken: getNewCancelToken(),
      });
      return data;
    },
    async update(id, payload) {
      const { data } = await axiosInstance.put(`${basePath}/${id}`, payload, {
        cancelToken: getNewCancelToken(),
      });
      return data;
    },
    async remove(id) {
      const { data } = await axiosInstance.delete(`${basePath}/${id}`, {
        cancelToken: getNewCancelToken(),
      });
      return data;
    },
  };
}

export function isOk(body) {
  return !!(body && body.status && body.status.error === 0);
}

export function bodyMessage(body) {
  return validationText(body && body.status ? body.status.message : '');
}
